import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AcademyAdvantages from '@components/AcademyAdvantages/AcadamyAdvantages';
import AcademyMethods from '@components/AcademyMethods/AcademyMethods';
import AcademyProductsTemplate from '@components/AcademyProducts2/AcademyProducts';
import EventTemplate from '@components/Event/Event';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import HeroTemplate from '@ui/Hero/Hero';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';
import { IAcademyItem2 } from '../interfaces/Calendar';
import { calendarApi } from '../services/calendar.service';

interface IAcademy {
    events: IAcademyItem2[];
    eventsCount: number;
}

const Academy: NextPage<IAcademy> = ({ events, eventsCount }) => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.academy.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="academy.hero.title"
                imageKey="educationalPrograms.webp"
                descriptionKey="academy.hero.description"
                listKeys={[
                    'academy.hero.paragraph1',
                    'academy.hero.paragraph2',
                    'academy.hero.paragraph3',
                    'academy.hero.paragraph4'
                ]}
            />
            <AcademyMethods />
            <AcademyProductsTemplate
                events={events}
                eventsCount={eventsCount}
            />
            <AcademyAdvantages />
            <FooterTemplate />
        </>
    );
};

export async function getServerSideProps(ctx: any) {
    try {
        const { data: academies } = await calendarApi.getAcademies2();
       
        return {
            props: {
                events: academies?.results,
                eventsCount: academies?.total_count
            },
        };
    } catch {
        return {
            props: {
                events: [],
                eventsCount: 0
            },
        };
    }
}

export default Academy;
